function getNextTrialRowNumber(newTrial, lastTrialRow, skipLogic) {
	console.log('newTrial', newTrial);

	if (newTrial >= window.stimOrder.length && columnForTrial('then', lastTrialRow) == 'na') {
		console.log('out of bounds trial, %d', newTrial);
		return undefined;
	}

	var lastResponse = window.allResponses[window.allResponses.length - 1];
	var lastResponseCode = window.allResponseCodes[window.allResponseCodes.length - 1];
	var lastCorrect = window.allCorrects[window.allCorrects.length - 1] === "1";
	var lastRT = window.allRTs[window.allRTs.length - 1];
	var nextTrialLogic = computeNextTrialLogic(lastTrialRow, lastResponse, lastResponseCode, lastCorrect, lastRT, skipLogic);

	console.log('computeNextTrialLogic result',  newTrial, nextTrialLogic);

	if (prevScreenType === 'test' && nextTrialLogic !== -1) {
		if (nextTrialLogic >= window.stimOrder.length) {
			console.log('out of bounds trial, %d', nextTrialLogic);
			return undefined;
		}

		window.trial = nextTrialLogic;

		return window.stimOrder[window.trial];
	}

	var newTrialRow = window.stimOrder[newTrial];
	var isStaircase = newTrialRow !== undefined && columnForTrial('staircase', newTrialRow) != 'na';

	console.log('staircase value for trial', newTrialRow, window.trialStaircases[newTrialRow]);
	console.log('isStaircase', isStaircase)

	if (window.inStaircaseGroupIndex == -1 && (!isStaircase || window.trialStaircases[newTrialRow] < 0)) {
		return newTrialRow;
	}

	var staircaseIndexGroup = window.inStaircaseGroupIndex >= 0 ? window.inStaircaseGroupIndex : window.trialStaircases[newTrialRow]; // stay in thre same group or move if not in any group
	var candidateStaircases = window.staircases[staircaseIndexGroup];
	var staircaseIndexInGroup = getRandomInteger(0, candidateStaircases.length - 1);
	var staircase = candidateStaircases.length == 1 ? candidateStaircases[0] : candidateStaircases[staircaseIndexInGroup];
	var trialRowOffset = 1;

	if (!staircase) {
		// this usually means that the staircases was already finished
		return undefined;
	}

	window.inStaircaseGroupIndex = staircaseIndexGroup;
	console.log('current group index', window.inStaircaseGroupIndex);
	console.log('staircase', staircase.props.id);

	if (!staircase.state.started) {
		// new staircase
		staircase.state.started = true;
		newTrialRow = staircase.props.startTrialRow + staircase.props.start - 1; // -1 because start is starting from 1
		console.log('start of staircase %s at trial inde %d in stimOrder', staircase.props.id, staircase.props.startTrialRow + staircase.props.start - 1,  newTrialRow);
	} else {
		// should we use stimOrder here???
		newTrialRow = staircase.state.lastTrialRow; // stay at the same trial from staircase
		console.log('check correct for last staircase row', staircase.state.lastCorrectIndex, correct[staircase.state.lastCorrectIndex]);
		var wasCorrectLastAnswer = correct[staircase.state.lastCorrectIndex] === "1";
		var newTrend = null;

		if (wasCorrectLastAnswer) {
			staircase.state.correct++;
			console.log('correct at', staircase.state.correct)
			if (staircase.props.correct == staircase.state.correct) {
                // use boost as long as the user did not fail, this way a participants who is really good can move faster
                const downStep = staircase.state.reversals > 0 || staircase.state.lastTrend === 'up' ? staircase.props.down : staircase.props.boost;
				newTrialRow = staircase.state.lastTrialRow + downStep; // move down								
                newTrend = 'down';
                console.log('moving down to', newTrialRow);
			}
		} else {
			staircase.state.incorrect++;
			console.log('inccorrect at', staircase.state.incorrect)
			if (staircase.props.incorrect == staircase.state.incorrect) {
				newTrialRow = staircase.state.lastTrialRow - staircase.props.up; // move up
				newTrend = 'up'
				console.log('moving up to', newTrialRow);
			}
		}

		// TODO useless??
		if (newTrend && !staircase.state.lastTrend) {
			staircase.state.lastTrend = newTrend;
		}

		if (newTrend) {
			// reset counters
			staircase.state.correct = 0;
			staircase.state.incorrect = 0;
		}

		if (newTrend && staircase.state.lastTrend && staircase.state.lastTrend != newTrend) {
			// direction was changed
			staircase.state.reversals++;
			console.log('direction changed %d for %s (old: %s, new: %s)', staircase.state.reversals, staircase.props.id, staircase.state.lastTrend, newTrend);
		}

		if (newTrend) {
			staircase.state.lastTrend = newTrend;
		}
	}

	console.log(staircase.state);

	staircase.state.lastTrialRow = newTrialRow;
	staircase.state.lastCorrectIndex = correct.length;
	staircase.state.trials++;

	// staircaseResults[responses.length - 1] = 0;
	window.trial--;

	//exit staircase conditions
	if (
		staircase.state.reversals >= staircase.props.reversals  // too many direction changes
		|| staircase.state.trials > staircase.props.trials     // too many trials
		|| newTrialRow < staircase.props.startTrialRow  		//out of staircase lower bound
		|| newTrialRow > staircase.props.lastTrialRow 			//out of staircase upper bounds
	) {
		staircase.state.reversals >= staircase.props.reversals && (console.log('staircase ended because of to many reversals'));
		staircase.state.trials > staircase.props.trials && (console.log('staircase ended because of to many trials'));
		newTrialRow < staircase.props.startTrialRow && (console.log('staircase ended at %d because of out of lower bounds %d', newTrialRow, staircase.props.startTrialRow));
		newTrialRow > staircase.props.lastTrialRow && (console.log('staircase ended because of out of upper bounds'));

		staircaseResults[responses.length - 1] = 1;

		var removedStaircase = window.staircases[staircaseIndexGroup].splice(staircaseIndexInGroup, 1);
		console.log('ended staircase', removedStaircase[0] && removedStaircase[0].props.id, removedStaircase[0], window.staircases[staircaseIndexGroup]);

		if ( window.staircases[staircaseIndexGroup].length === 0 ) {
			console.log('group ended', window.inStaircaseGroupIndex);
			window.inStaircaseGroupIndex = -1; // no more staircases in group
			// we need to end this staircase and move to the next trial after te group
			// TODO check this is ok
			var indexInStimOrder = indexInArray(window.stimOrder, staircase.props.groupEndTrialRow);

			console.log('next trial after this staircase group is %d', indexInStimOrder);

			if (indexInStimOrder < 0) {
				throw "Could not find the last trial of this staircase group";
			}

			window.trial = indexInStimOrder + 1; // next trial after staircase
			newTrialRow = getNextTrialRowNumber(window.trial);
			console.log('next trial after group ended', newTrialRow);
		} else {
			// we still have staircases in this group so moving to them
			newTrialRow = getNextTrialRowNumber(newTrial);
			console.log('next trial in the same group', newTrialRow);
		}
	}

	console.log('next trial', newTrialRow);

	return newTrialRow;
}


function indexInArray(array, value) {
	for (var i = 0; i < array.length; i++) {
		if (array[i] == value) {
			return i;
		}
	}

	return -1;
}

function computeNextTrialLogic(lastTrialRow, lastResponse, lastResponseCode, lastCorrect, lastRT, skipLogic) {
	if(columnForTrial('then', lastTrialRow) == 'na' || skipLogic){
		return -1;
	}
	console.log('computeNextTrialLogic', lastTrialRow);

	var fn = window.trialsLogicFn[lastTrialRow];

	if (!(fn instanceof Function)) {
		return -1;
	}

	if(lastResponseCode != undefined){ 
		lastResponseCode = sortResponseCodes(lastResponseCode);
	}

	var nextTrialLogic = fn(lastResponse, lastResponseCode, lastCorrect, lastRT);
	console.log('nextTrialLogic ', nextTrialLogic, arguments, fn); 

	if(nextTrialLogic === 'startBreakTimestamp'){
		window.startBreakTimestamp();
		return -1;
	}

	if(nextTrialLogic === 0){
		return window.stimOrder.indexOf(lastTrialRow);
	}

	if (nextTrialLogic === undefined) {
		return -1;
	}

	// absolute trial number
	if (Number.isInteger(nextTrialLogic)) {
		var nextTrial = window.stimOrder.indexOf(window.trialData.trialInitialRows[nextTrialLogic]);
		if(nextTrial === -1){
			return undefined;
		}
		return nextTrial;
	}

	// end experiment
	if (nextTrialLogic.toLowerCase() === 'end') {
		return undefined;
	}

	if(nextTrialLogic.toLowerCase() === 'screenout') {
		screenout();
		return -1;
	}

	// relative change
	if (nextTrialLogic[0] === '-' || nextTrialLogic[0] === '+') {
		var nextTrial = window.stimOrder.indexOf(lastTrialRow) + parseInt(nextTrialLogic);
		if(nextTrial < 0 || nextTrial >= window.stimOrder.length){
			return undefined;
		}
		return nextTrial;
	}

	//redirect to url
	if(isValidUrl(nextTrialLogic)){
		var finalUrl = replaceUrlVars(nextTrialLogic);
		document.getElementsByTagName("body")[0].style.display = "none";
		window.logExperimentEvent(window.consortEvents.REDIRECTED);
		window.removeEventListener("unload", leaveBeforeEnd);
		window.location.href = addCurrentQueryParamsToUrl(replaceQueryParamsPlaceholders(replaceVariables(finalUrl)));
		throw ''; //halt all js executiuon kinda hacky 
	}

	// advance by label
	var trialWithLabel = getTrialWithLabel(nextTrialLogic);
	if (trialWithLabel > -1) {
		var nextTrial = window.stimOrder.indexOf(trialWithLabel);
		if(nextTrial === -1){
			return undefined;
		}
		return nextTrial;
	}

	return -1;
}

function getTrialWithLabel(trialLabel) {
	if(window.trialLabels === undefined) {
		window.trialLabels = window.trialData?.trialLabels || [];
	}

	if (window.trialLabels[trialLabel] !== undefined)  {
		return window.trialLabels[trialLabel];
	}

	return -1;
}

function isValidUrl(url){
	if (url.startsWith('https://') || url.startsWith('http://')) {
		try{
			new URL(url);
			return true;
		}
		catch (_){
			return false;
		}
	}
	return false;
}

function replaceUrlVars(url){
	var re = /%%(\w+)%%/g;
	var currentMatch = re.exec(url);
	while(currentMatch!=null){
		var url_var_prefix = "url_";
		if(currentMatch[1] && currentMatch[1].indexOf(url_var_prefix)>=0){
			var paramName = currentMatch[1].replace(url_var_prefix, '');
			var param = getParameterByName(paramName);
			url = url.replace(currentMatch[0], param);
		}
		currentMatch = re.exec(url);
	}
	return url;
}